import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Device-local map cosmetic preferences. Persisted to localStorage via
 * zustand's `persist` middleware (same pattern as useAuthStore), so the choice
 * survives across sessions on this device. Account-independent on purpose: the
 * cluster-ring toggle is a per-device cosmetic preference, not an account
 * setting — mirroring how the theme is device-local rather than server-synced.
 */
interface MapPrefsState {
  /** When true, map cluster beacons render the status-segmented ring
   *  (EviMapDot's opt-in `statusCounts` prop). Default false — beacons show
   *  plain glowing pulsing dots until the driver opts in from Settings. The
   *  ring code itself always exists; this only controls whether it's used. */
  showClusterStatusRing: boolean;
  setShowClusterStatusRing: (v: boolean) => void;
}

export const useMapPrefsStore = create<MapPrefsState>()(
  persist(
    (set) => ({
      showClusterStatusRing: false,
      setShowClusterStatusRing: (v) => set({ showClusterStatusRing: v }),
    }),
    { name: 'evi-web-map-prefs' },
  ),
);
